import type { ChangeEvent, MouseEvent } from "react"
import React, { useState } from "react"
import axios, { AxiosError } from "axios"
import { UniversalLink } from "../UniversalLink"
import "./cta.scss"

// TODO: Leverage Card component
export const CallToAction = () => (
  <div className="cta">
    <div className="max-w-sm rounded overflow-hidden shadow-lg cta-card">
      <div className="cta-card-inner">
        <h2>Applications for the XRPL Accelerator are now open!</h2>
        {/* <div className="apply-now">
          <UniversalLink
            className="btn btn-primary btn-fixed"
            to="https://submit.xrplgrants.org/submit"
          >
            <span>Apply&nbsp;Now</span>
            <span className="arrow">&#10132;</span>
          </UniversalLink>
        </div> */}
      </div>
    </div>
  </div>
)
